import React from "react";
import "./PendingVodCard.css";
export default function PendingVodCard({ title, povName, progress = 0, status = "uploading", message }) {
  const percent = Math.min(100, Math.max(0, Number(progress) || 0));
  const label = status === "error" ? "Upload needs attention" : status === "finalizing" ? "Saving VOD…" : status === "paused" ? "Upload paused" : status === "uploading" ? "Uploading VOD" : "VOD queued";
  return <article className="pending-vod-card" aria-label={label} aria-busy={status !== "error"}>
    <header><strong>{title || "New VOD"}</strong><span role="status">{label}</span></header>
    <div className="pending-vod-card__pov">{povName || "POV"}</div>
    <div className="pending-vod-card__skeleton" aria-hidden="true"><span /><span /></div>
    <progress max="100" value={percent} aria-label="VOD upload progress" />
    <small>{message || (status === "uploading" ? percent.toFixed(1) + "% uploaded" : label)}</small>
  </article>;
}
